import { render, staticRenderFns } from "./serverLisyRecordsz.vue?vue&type=template&id=5481d660&"
import script from "./serverLisyRecordsz.vue?vue&type=script&lang=js&"
export * from "./serverLisyRecordsz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5481d660')) {
      api.createRecord('5481d660', component.options)
    } else {
      api.reload('5481d660', component.options)
    }
    module.hot.accept("./serverLisyRecordsz.vue?vue&type=template&id=5481d660&", function () {
      api.rerender('5481d660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/serverManagement/serverLisyRecordsz.vue"
export default component.exports